// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Zj9cy","header":"Header_header__JDjcR","errorMessage":"Header_errorMessage__svyK4"};